import type { Locale } from "../shared/types";

const STORAGE_KEY = "echos-events-locale";

export function initialLocale(): Locale {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved === "tr" || saved === "en") return saved;
  } catch {
    // Browser language still works when storage is unavailable.
  }
  const language = navigator.languages?.[0] || navigator.language || "en";
  return language.toLowerCase().split("-")[0] === "tr" ? "tr" : "en";
}

export function saveLocale(locale: Locale): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    // A manual choice must still work for this visit without storage.
  }
}
